import * as yup from 'yup';

export const getProfilePasswordSchema = yup.object().shape({
  currentPassword: yup
    .string()
    .min(6, 'Votre mot de passe doit contenir au moins 6 caractères')
    .required('Votre mot de passe actuel est requis'),
  password: yup
    .string()
    .min(6, 'Votre mot de passe doit contenir au moins 6 caractères')
    .required('Un mot de passe est requis'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Les mots de passe ne correspondent pas')
    .required('La confirmation de votre mot de passe est requise'),
});
